import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

export default function Sonaca({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Sonaca" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="sonacaPanel">
            <Trans i18nKey="sonacaDetails" />

            <h2 className="text-center titles text-green-300">{t("technologies")}</h2>

            <p className="text-center"><Trans i18nKey="sonacaSkills" /></p>
        </Dialog>
    )
}